module.exports = __webpack_public_path__ + "img/loading.c0b8ea9d.svg";